import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer/lib/popSignUp";

interface IProps {
  primary?: boolean;
  "data-test-id"?: string;
}

export const SignUpButton: React.FC<IProps> = ({
  primary = false,
  "data-test-id": dataTestId = "signUpButton",
}) => {
  const history = useHistory();
  const handleSignUp = () =>
    popSignUp(history, SignUpType.FAIRE_DIRECT, () => null, {
      element: SignUpElement.HEADER,
      sourceId: "fd_landing_sign_up_button",
    });

  return (
    <StyledButton
      onClick={handleSignUp}
      variant={primary ? "primary" : "secondary"}
      data-test-id={dataTestId}
    >
      <StrictLocalMsg
        defaultMessage="Start Shopping"
        description={{ text: "Button to sign up and start shopping" }}
      />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  width: fit-content;
  min-width: 200px;
`;
